function createExtensionDataRef() {
  const createRef = (refId) => Object.assign(
    (value) => ({
      $$type: "@backstage/ExtensionDataValue",
      id: refId,
      value
    }),
    {
      id: refId,
      $$type: "@backstage/ExtensionDataRef",
      config: {},
      optional() {
        return {
          ...this,
          config: { ...this.config, optional: true }
        };
      },
      toString() {
        const optional = Boolean(this.config.optional);
        return `ExtensionDataRef{id=${refId},optional=${optional}}`;
      }
    }
  );
  return {
    with(options) {
      return createRef(options.id);
    }
  };
}

export { createExtensionDataRef };
//# sourceMappingURL=createExtensionDataRef.esm.js.map
